module.exports = __webpack_public_path__ + "img/退出登录-2.a09e4bb6.png";